function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppVersion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.254,
    height: 20.254,
    viewBox: "0 0 20.254 20.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6667",
    d: "M80.127 1.215a8.912 8.912 0 1 1-8.912 8.912 8.912 8.912 0 0 1 8.912-8.912m0-1.215a10.127 10.127 0 1 0 10.127 10.127A10.13 10.13 0 0 0 80.127 0z",
    style: {
      fill: "#aeaeae"
    },
    transform: "translate(-70)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6668",
    d: "M203.328 225.21v5.266h-8.912v-5.266h8.912m.405-1.215h-9.722a.812.812 0 0 0-.81.81v6.076a.812.812 0 0 0 .81.81h9.722a.812.812 0 0 0 .81-.81V224.8a.813.813 0 0 0-.81-.81z",
    transform: "translate(-188.745 -215.893)",
    style: {
      fill: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6669",
    d: "M216.006 190.4h8.912a.405.405 0 1 1 0 .81h-8.912a.405.405 0 0 1 0-.81z",
    transform: "translate(-210.335 -183.514)",
    style: {
      fill: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6670",
    d: "M249.606 156.8h6.481a.405.405 0 1 1 0 .81h-6.481a.405.405 0 0 1 0-.81z",
    transform: "translate(-242.72 -151.129)",
    style: {
      fill: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6671",
    d: "M283.206 123.2h4.051a.405.405 0 0 1 0 .81h-4.051a.405.405 0 0 1 0-.81z",
    transform: "translate(-275.105 -118.744)",
    style: {
      fill: "#aeaeae"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppVersion);
export default __webpack_public_path__ + "static/media/app-version.fe1477d4d7a3ce256efcf7b3d3b6c86d.svg";
export { ForwardRef as ReactComponent };